<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import {mapGetters, mapActions, mapState} from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Consumables Stock",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Consumables Stock",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Consumables Stock",
          active: true,
        },
      ],
      totalRows: 1,
      total_amount: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/No",
        },
        {
          key: "name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNIT_MEASURE",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY IN STOCK",
        },
        {
          key: "buying_price",
          sortable: true,
          label: "BUYING PRICE",
        },
      ],

      json_fields: {
        NAME: "name",
        UNIT: "unit",
        QUANTITY: "quantity",
        MINIMUM_QUANTITY: "minimum_quantity",
        BUYING_PRICE: "buying_price",
      },

      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("consumables", ["Consumables"]),
    ...mapGetters("auth", ["branchid", "Branches"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Consumables ? this.Consumables.length : 1;
    },

    exportData() {
      if (this.Consumables && this.Consumables.length > 0) {
        // Take first 2 consumables as samples, or all if less than 2
        return this.Consumables.map((consumable) => ({
          name: consumable.name,
          unit: consumable.unit?.name || "",
          quantity: consumable.qty,
          minimum_quantity: consumable.minimum_quantity,
          buying_price: consumable.buying_price,
        }));
      }
      return [];
    },
    computedFields() {
      let basefields = [...this.fields];
      if (this.Consumables && this.Consumables.length > 0) {
        if (this.branchid == 0) {
          const position = basefields.length > 0 ? basefields.length - 3 : basefields.length;
          basefields.splice(position, 0, {
            key: "branch.name",
            label: "Branch",
          });
        }
      }
      return basefields;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Consumables ? this.Consumables.length : 1;
    this.calculateTotalAmount();
  },
  methods: {
    ...mapActions({
      FetchConsumableStock: "consumables/fetchConsumables",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.calculateTotalAmount();

    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    calculateTotalAmount() {
      if (this.Consumables) {
        this.total_amount = this.Consumables.reduce((total, item) => {
          // Ensure buying_price and qty are numbers.  Handle null/undefined/empty.
          const price = parseFloat(String(item.buying_price).replaceAll(/,/g, '')) || 0;
          const quantity = parseFloat(item.qty) || 0;
          return total + (price * quantity);
        }, 0);
      } else {
        this.total_amount = 0;
      }
    },
  },
  created() {
    this.FetchConsumableStock();
  },
  watch: {
    Consumables: {
      handler() {
        // Recalculate whenever Consumables data changes
        this.calculateTotalAmount();
      },
      deep: true, // Watch for changes within the Consumables array
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 text-end flex-grow-1">
                <download-excel
                    class="btn btn-info"
                    :fields="json_fields"
                    :data="exportData"
                    type="xls"
                    :name="'consumables_stock.xls'"
                >
                  Export <i class="fas fa-download"></i>
                </download-excel>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="Consumables ? Consumables : []"
                  :fields="computedFields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>
            <Loader v-if="!Consumables"/>
            <div class="row mt-3 text-center">
              <h5>
                Buying Price Stock Value:
                <span class="text-danger">
                    {{ total_amount.toLocaleString() }}
                  </span>
              </h5>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary, .page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
